"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
const js_string_escape_1 = __importDefault(require("js-string-escape"));
class StringUtils {
    static escapeJsString(string) {
        return js_string_escape_1.default(string);
    }
}
exports.StringUtils = StringUtils;
